import DiscountCircleLabel from './DiscountCircleLabel';
import LoyaltyPointsLabel from './LoyaltyPointsLabel';
import RewardStatus from './RewardStatus';

export default {
  DiscountCircleLabel,
  LoyaltyPointsLabel,
  RewardStatus,
};
